import { useQuery } from '@tanstack/react-query';
import { customInstance } from '../mutator/custom-instance';

export interface VersionInfo {
    version: string;
    poweredBy: string;
    website: string;
}

export const getVersion = (signal?: AbortSignal) => {
    return customInstance<VersionInfo>(
        { url: `/public/appearance/version`, method: 'GET', signal }
    );
};

export const getVersionQueryKey = () => ['/public/appearance/version'] as const;

export const useGetVersion = () => {
    return useQuery({
        queryKey: getVersionQueryKey(),
        queryFn: ({ signal }) => getVersion(signal),
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
};
